import { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  List,
  ListItemButton,
  ListItemText
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

export default function Configurations() {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const mode = params.get("mode");

  const heading = mode === "maintenance" ? "Maintenance" : "Configurations";

  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);

  const [featuresList, setFeaturesList] = useState([]);
  const [selectedFeature, setSelectedFeature] = useState(null);

  const [itemsList, setItemsList] = useState({});

  // Fetch Modules
  useEffect(() => {
    fetch("https://apiservices.iepa.in:8191/iepa/api/configuration/org/1")
      .then((res) => res.json())
      .then(setModules)
      .catch(console.error);
  }, []);

  // Fetch Features & Items
  const loadFeatures = async (moduleId) => {
    setSelectedModule(moduleId);
    setSelectedFeature(null);
    setFeaturesList([]);
    setItemsList({});

    try {
      const res = await fetch(
        `https://apiservices.iepa.in:8191/iepa/api/configuration/${moduleId}/org/1`
      );
      const data = await res.json();

      // Features = name field
      const featureNames = [...new Set(data.map((d) => d.name))];
      setFeaturesList(featureNames);

      // Group uriPath by feature
      const grouped = {};
      data.forEach((d) => {
        if (!grouped[d.name]) grouped[d.name] = [];
        grouped[d.name].push(d.uriPath);
      });

      setItemsList(grouped);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box p={2}>
      <Typography variant="h4" mb={2}>
        {heading}
      </Typography>

      <Grid container spacing={2}>
        {/* MODULES */}
        <Grid item xs={4}>
          <Paper sx={{ height: "80vh", overflow: "auto" }}>
            <Typography variant="h6" p={2}>
              Modules List
            </Typography>

            <List>
              {modules.map((m) => (
                <ListItemButton
                  key={m.id}
                  selected={selectedModule === m.id}
                  onClick={() => loadFeatures(m.id)}
                >
                  <ListItemText primary={m.name} />
                </ListItemButton>
              ))}
            </List>
          </Paper>
        </Grid>

        {/* FEATURES */}
        <Grid item xs={4}>
          <Paper sx={{ height: "80vh", overflow: "auto" }}>
            <Typography variant="h6" p={2}>
              Features
            </Typography>

            {selectedModule ? (
              <List>
                {featuresList.map((f, idx) => (
                  <ListItemButton
                    key={idx}
                    selected={selectedFeature === f}
                    onClick={() => setSelectedFeature(f)}
                  >
                    <ListItemText primary={f} />
                  </ListItemButton>
                ))}
              </List>
            ) : (
              <Typography p={2}>Select a module</Typography>
            )}
          </Paper>
        </Grid>

        {/* ITEMS (URI PATHS) */}
        <Grid item xs={4}>
          <Paper sx={{ height: "80vh", overflow: "auto" }}>
            <Typography variant="h6" p={2}>
              Items
            </Typography>

            {selectedFeature ? (
              <List>
                {(itemsList[selectedFeature] || []).map((uri, idx) => {
                  const clean = uri.replace("/", "");

                  return (
                    <ListItemButton
                      key={idx}
                      onDoubleClick={() => navigate(uri)}
                    >
                      <ListItemText
                        primary={clean}
                        sx={{ color: "blue" }}
                      />
                    </ListItemButton>
                  );
                })}
              </List>
            ) : (
              <Typography p={2}>Select a feature</Typography>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
